import { render, staticRenderFns } from "./clientCoders.vue?vue&type=template&id=2c804eae&scoped=true&"
import script from "./clientCoders.vue?vue&type=script&lang=js&"
export * from "./clientCoders.vue?vue&type=script&lang=js&"
import style0 from "./clientCoders.vue?vue&type=style&index=0&id=2c804eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c804eae",
  null
  
)

export default component.exports